import { Component, EventEmitter, Input, Output } from "@angular/core";

export type AlertType = "success" | "error" | "warning" | "info";

@Component({
    selector: "app-alert-banner",
    template: require("./alert-banner.component.html"),
})
export class AlertBannerComponent {
    @Input() type: AlertType = "info";
    @Input() title?: string;
    @Input() dismissible = false;
    @Output() dismissed = new EventEmitter<void>();

    get isCritical(): boolean {
        return this.type === "error" || this.type === "warning";
    }

    dismiss(): void {
        this.dismissed.emit();
    }
}
